module.exports = __webpack_public_path__ + "static/media/Samurai_Fraser_Menu.04786535.pdf";